//GeneratorFlag:[NoChange]
<template>
	<div>kaveh.app.toolbar.messenger.notification</div>
</template>